"use strict";
angular.module("makeFastNewsModule", [])
    .controller("makeFastNewsCtrl", ["$scope", "$filter", "$modalInstance", "item", "trsHttpService", "modalDialog", "$validation", function($scope, $filter, $modalInstance, item, trsHttpService, modalDialog, $validation) {
        initStatus();
        initData();
        /** [initStatus description]初始化状态 */
        function initStatus() {
            $scope.data = {
                title: '', // 制作快讯标题
                selectedArray: [], // 选中的稿件
                item: '',
                newsList: {}
            };
        }

        /** [initData description]初始化数据 */
        function initData() {
            $scope.data.title = item.curTime + '热点新闻快讯';
            $scope.data.item = angular.copy(item);
            reqFastNews();
        }

        /**
         * [reqFastNews description]查询快讯列表
         * @return {[type]} [description]
         */
        function reqFastNews() {
            var params = {
                typeid: "widget",
                serviceid: "periodhotpoint",
                modelid: "makeQuickInfo",
                guids: $scope.data.item.docGuids,
                starttime: $scope.data.item.starttime,
                endtime: $scope.data.item.endtime
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                if (data.STATUS && data.STATUS == 'success') {
                    $scope.data.newsList = data.CONTENT;
                }
            });
        }

        /**
         * [singleSelect 单选]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function(itemval) {
            var n = $scope.data.selectedArray.indexOf(itemval);
            n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(itemval);
        };

        /** [confirm description] 取稿*/
        $scope.confirm = function() {
            $modalInstance.dismiss();
        };
        /** [cancel description] 关闭弹窗*/
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [pullDown 展开]
         * @return {[type]} [description]
         */
        $scope.pullDown = function(val) {
            val.isPullDown = true;
        }

        /**
         * [pullUp 收起]
         * @return {[type]} [description]
         */
        $scope.pullUp = function(val) {
            val.isPullDown = false;
        }
    }]);